<div class="container">
  <fa-icon class="loader" [class.shown]="!(atlasFixFilterService.atlasFixService.olMapService.filters?.[0]?.choices?.length > 0)" [icon]="icons.falSpinnerThird" animation="spin"></fa-icon>
  @if (atlasFixFilterService.atlasFixService.olMapService.filters?.[0]?.choices?.length > 0) {
    <app-area-select
      [(selectedArea)]="selectedArea"
      (selectedAreaChange)="onSearchArea($event)"
    ></app-area-select>
    <div>
      @for (fil of atlasFixFilterService.atlasFixService.olMapService.filters; track fil) {
        <app-atlas-filter-field
          [label]="fil.label"
          [value]="atlasFixFilterService.atlasFixService.olMapService.filter.get(fil.key)"
          [multiple]="fil.multiple"
          [choices]="fil.choices"
          (valueChange)="setFilter(fil.key, $event)"
        ></app-atlas-filter-field>
      }
    </div>
  }
</div>